import { Grid, Table } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FieldsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginBottom: "16px",

  "& .MuiBox-root": {
    display: "flex",
    gap: "10px",

    "&>div": {
      width: "100%",
    },
  },

  "& .MuiFormGroup-root": {
    display: "flex",
    flexDirection: "row",
  },
});

export const EmployeeInfoBox = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: 2,
});

export const StyledTable = styled(Table)(({ theme }) => ({
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
